var map = {
	"./music-instructions.json": 4730,
	"./music-library-intro2024.json": 4731,
	"./music-library-launch2024.json": 4732,
	"./music-progression.json": 4733,
	"./startSourcesAdvanced.json": 4734,
	"./startSourcesSimple.json": 4735,
	"./startSourcesSimple2.json": 4736,
	"./startSourcesTracks.json": 4737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4499;